import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SelectAllIcon(props: IconProps) {
    return <Icon {...props} iconKey={"select_all"}/>
}
